module.exports = __webpack_public_path__ + "static/media/Noi-Treatments.ed241e49.jpg";